import __request__ from "routing/request";
export function createExternalAction(action, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.contentui/external_actions", action, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getExternalActions(page = 1, page_size = 50, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.contentui/external_actions", null, { "page": page, "page_size": page_size }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getExternalActionsMapping(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.contentui/external_actions/ui_mapping", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getById(id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.contentui/external_actions/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateExternalAction(id, action, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.contentui/external_actions/${id}`, action, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteExternalAction(id, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.contentui/external_actions/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
